import { combineReducers } from "redux";
import getAllCountries from "./getAllCountriesReducer";

export default combineReducers({
  getAllCountries
});
